// packages/web/src/services/userAssignmentApi.ts
import axios from 'axios';

const API_BASE_URL = import.meta.env.VITE_API_BASE_URL || 'http://localhost:5000';

const apiClient = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
  withCredentials: true,
});

// 请求拦截器：添加 token
apiClient.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('auth_token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// 响应拦截器：统一错误处理
apiClient.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem('token');
      window.location.href = '/login';
    }
    return Promise.reject(error);
  }
);

export const userAssignmentApi = {
  /**
   * 获取学生的作业列表
   * @param filter - 筛选条件：all, pending, completed
   */
  async getAssignments(filter: 'all' | 'pending' | 'completed' = 'all'): Promise<any> {
    const response = await apiClient.get(`/user/assignments?filter=${filter}`);
    return response.data;
  },

  /**
   * 获取作业详情
   */
  async getAssignmentDetail(assignmentId: string): Promise<any> {
    const response = await apiClient.get(`/user/assignments/${assignmentId}`);
    return response.data;
  },
};
